/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
import LikeHeartFill from 'wix-ui-icons-common/on-stage/LikeHeartFill';
var love_full = function (_a) { return (React.createElement(LikeHeartFill, { size: "24" })); };
love_full.displayName = 'love_full';
love_full.propTypes = {
    size: PropTypes.string
};
export default love_full;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=love_full.js.map